// index.tsx
import "./logger"; // Import the logger so logging overrides are activated immediately
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'govuk-frontend/dist/govuk/govuk-frontend.min.css';
import "./index.css";
import './i18n';  // Ensure i18n is initialized
//import "./fetchLogger";

/*
const oneLoginSub = new URLSearchParams(window.location.search).get("oneLoginSub");
if (oneLoginSub) {
  localStorage.setItem("oneLoginSub", oneLoginSub);
}
*/

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <Suspense fallback={<div>Loading translations...</div>}>
      <App />
    </Suspense>
  </BrowserRouter>
);
